import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Attachment } from 'app/models/api/attachment';
import { API_ENDPOINT } from 'app/services/utils.service';
import { ApiResponse } from 'app/models/api/api-response';

@Injectable({ providedIn: 'root' })
export class AttachmentsService {
  private http = inject(HttpClient);


  getAttachments(machineId: string): Observable<Attachment[]> {
    return this.http.get<ApiResponse<Attachment>>(`${API_ENDPOINT}/machines/${machineId}/attachments`).pipe(
      map(data => data.items),
    );
  }
}
